import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BuildingClassClient, BuildingClassView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class BuildingClassService {
    constructor(private readonly client: BuildingClassClient) {}

    async getAll(): Promise<BuildingClassView[]> {
        return await lastValueFrom(this.client.buildingClassGetAll());
    }
}
